module.exports = __webpack_public_path__ + "img/Tiktok.87b010ca.png";